import { useMemo } from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { AppBar as MuiAppBar, Button, Grid, Toolbar, useMediaQuery, useTheme } from '@material-ui/core';

import { getIsACT, URLsManager } from '$app-web/utils';

import useStyles from './styles';

import { FontAwesomeIcon } from '$common/fontawesome-pro/react-fontawesome';

const AppBar = (props) => {
    const { hasStudyBasicInfo } = props;

    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();
    const theme = useTheme();
    const isACT = useMemo(() => getIsACT(), []);

    const matchedRoutes = {
        welcome: Boolean(useRouteMatch(URLsManager.to('dashboard:auth:WELCOME'))),
        signIn: Boolean(useRouteMatch(URLsManager.to('dashboard:auth:SIGN_IN'))),
        signUp: Boolean(useRouteMatch(URLsManager.to('dashboard:auth:SIGN_UP'))),
        signUpRoleParticipant: Boolean(useRouteMatch(URLsManager.to('dashboard:auth:SIGN_UP_ROLE', { role: 'participant' }))),
        signUpRoleResearcher: Boolean(useRouteMatch(URLsManager.to('dashboard:auth:SIGN_UP_ROLE', { role: 'researcher' }))),
        forgotPassword: Boolean(useRouteMatch(URLsManager.to('dashboard:auth:FORGOT_PASSWORD'))),
        forgotPasswordSuccess: Boolean(useRouteMatch(URLsManager.to('dashboard:auth:FORGOT_PASSWORD_SUCCESS'))),
        resetPassword: Boolean(useRouteMatch(URLsManager.to('dashboard:auth:RESET_PASSWORD'))),
    };

    const isSizeXsAndBelow = useMediaQuery(theme.breakpoints.down('xs'));
    const isFullSecondaryBackground =
        (matchedRoutes.signUp && !matchedRoutes.signUpRoleParticipant && !matchedRoutes.signUpRoleResearcher) ||
        (matchedRoutes.signUp && isSizeXsAndBelow);
    const isResearcherSecondaryBackground = matchedRoutes.signUpRoleResearcher && !isSizeXsAndBelow;
    const isParticipantSecondaryBackground = matchedRoutes.signUpRoleParticipant && !isSizeXsAndBelow;
    const backButtonColor = isFullSecondaryBackground || isResearcherSecondaryBackground ? 'primary' : 'secondary';

    const backgroundClass = isACT ? classes.actHealthBackground : classes.secondaryBackground;

    const onGoBack = () => {
        if (matchedRoutes.welcome) {
            URLsManager.redirectTo('/');
        } else if (matchedRoutes.signUpRoleParticipant || matchedRoutes.signUpRoleResearcher) {
            if (hasStudyBasicInfo) {
                history.push(URLsManager.to('dashboard:auth:WELCOME'));
            } else {
                history.push(URLsManager.to('dashboard:auth:SIGN_UP'));
            }
        } else if (matchedRoutes.signIn || matchedRoutes.signUp) {
            history.push(URLsManager.to('dashboard:auth:WELCOME'));
        } else if (matchedRoutes.forgotPassword) {
            history.push(URLsManager.to('dashboard:auth:SIGN_IN'));
        }
    };

    return (
        <MuiAppBar
            position="static"
            color="secondary"
            className={clsx(classes.root, {
                [backgroundClass]: isFullSecondaryBackground,
            })}
            elevation={0}
        >
            <Toolbar disableGutters>
                <Grid container wrap="nowrap" className={classes.contentWrapper}>
                    <Grid
                        item
                        container
                        alignItems="center"
                        className={clsx(classes.backButtonWrapper, classes.roleBackgroundWrapper, {
                            [backgroundClass]: isResearcherSecondaryBackground,
                        })}
                    >
                        {!(matchedRoutes.forgotPasswordSuccess || matchedRoutes.resetPassword) && (
                            <Button
                                className={
                                    isACT && !isFullSecondaryBackground && !isResearcherSecondaryBackground
                                        ? 'textACTColor'
                                        : undefined
                                }
                                color={backButtonColor}
                                onClick={onGoBack}
                                startIcon={<FontAwesomeIcon icon={['fal', 'angle-left']} size="sm" />}
                            >
                                {t('back')}
                            </Button>
                        )}
                    </Grid>
                    <Grid item xs />
                    <Grid
                        item
                        className={clsx(classes.roleBackgroundWrapper, {
                            [backgroundClass]: isParticipantSecondaryBackground,
                        })}
                    />
                </Grid>
            </Toolbar>
        </MuiAppBar>
    );
};

AppBar.propTypes = {
    hasStudyBasicInfo: PropTypes.bool,
};

AppBar.defaultProps = {
    hasStudyBasicInfo: false,
};

export default AppBar;
